export enum ExternalDataPaymentSystemEnum {
  VISA = 'VISA',
  MASTERCARD = 'MASTERCARD',
  MIR = 'MIR',
}
